import React, { createContext, useContext, useState, useEffect } from 'react';

const SiteSettingsContext = createContext();

const defaultSettings = {
  siteName: 'بوابة كلية المدينة',
  siteNameEn: 'Almadina College Portal',
  logoUrl: '/logo.png',
  primaryColor: '#176163',
  secondaryColor: '#b18b5e',
  timezone: 'Asia/Riyadh',
  dateFormat: 'DD/MM/YYYY',
  language: 'ar',
  emailNotifications: true,
  smsNotifications: true,
  notifyOnPayment: true,
  notifyOnEnrollment: true,
  notifyOnLead: true,
};

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(() => {
    try {
      const saved = localStorage.getItem('siteSettings');
      return saved ? { ...defaultSettings, ...JSON.parse(saved) } : defaultSettings;
    } catch {
      return defaultSettings;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('siteSettings', JSON.stringify(settings));
    } catch (e) {
      console.error('Failed to save site settings:', e);
    }
  }, [settings]);

  const updateSettings = (newSettings) => {
    setSettings(prev => ({ ...prev, ...newSettings }));
  };

  const resetSettings = () => {
    setSettings(defaultSettings);
    localStorage.removeItem('siteSettings');
  };

  return (
    <SiteSettingsContext.Provider value={{ settings, updateSettings, resetSettings, defaultSettings }}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  const context = useContext(SiteSettingsContext);
  if (!context) {
    throw new Error('useSiteSettings must be used within a SiteSettingsProvider');
  }
  return context;
}

export default SiteSettingsContext;
